import { render, staticRenderFns } from "./ModuleNetwork.vue?vue&type=template&id=d132a53e&"
import script from "./ModuleNetwork.vue?vue&type=script&lang=js&"
export * from "./ModuleNetwork.vue?vue&type=script&lang=js&"
import style0 from "./ModuleNetwork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports